import {Component, Input, OnInit} from '@angular/core';
import {Player} from "../../../../model/broadcast/player";
import {UtilService} from "../../../../services/util.service";
import {Broadcast} from "../../../../model/broadcast/broadcast";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-possition-player',
  templateUrl: './possition-player.component.html',
  styleUrls: ['./possition-player.component.scss'],
  imports: [
    NgIf
  ],
  standalone: true
})
export class PossitionPlayerComponent implements OnInit {

  @Input() player: Player;
  @Input() flipped?: boolean;
  @Input() bgColor: string;
  @Input() skipPortraits: boolean

  constructor(
    public utilService: UtilService,
  ) { }

  ngOnInit(): void {
  }

  getBgr(): string {
    if (this.player.position > 6) {
      return 'background-image:url(' + this.player.imageSrc + ');' +
        'animation-name: hide-75;' +
        'animation-duration: 7.5s;';
    }
    if (this.player.position > 2) {
      return 'background-image:url(' + this.player.imageSrc + ');' +
        'animation-name: hide-100;' +
        'animation-duration: 10s;';
    }
    return 'background-image:url(' + this.player.imageSrc + ');';
  }
}
